import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CartDrawer from '../components/cart/CartDrawer';
import { Link } from 'react-router-dom';
import { Shield, CheckCircle2, Award, ArrowRight } from 'lucide-react';
import { siteImages } from '../data/mock';

const QualityGuaranteePage = () => {
  useEffect(() => { document.title = 'Quality Guarantee | Motion Works Garage'; }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CartDrawer />

      <main>
        <section className="relative h-64 md:h-80 overflow-hidden bg-dark-900">
          <img src={siteImages.featuredBackground} alt="Quality Guarantee" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-r from-dark-900 via-dark-900/85 to-dark-900/40" />
          <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 border border-white/15 rounded-full text-athletic-300 text-xs font-semibold mb-4">
                <Shield className="w-3.5 h-3.5" /> OUR COMMITMENT
              </div>
              <h1 className="font-display text-4xl md:text-5xl text-white font-bold mb-3">Quality Guarantee</h1>
              <p className="text-dark-200 max-w-lg">Our commitment to shipping instruments you can trust.</p>
            </div>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-dark-50 border border-dark-100 rounded-3xl p-8 md:p-12 mb-16 text-center">
            <div className="w-20 h-20 bg-athletic-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Award className="w-10 h-10 text-white" />
            </div>
            <h2 className="font-display text-3xl lg:text-4xl text-dark-900 font-bold mb-6">Our quality promise</h2>
            <p className="text-dark-600 text-lg leading-relaxed max-w-3xl mx-auto">
              At Motion Works Garage, we stand behind every product we sell. We carefully select and vet all of our instruments to ensure they meet our standards for performance, build quality and value. If you&apos;re not completely satisfied, we&apos;ll make it right.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {[
              { icon: Shield, title: 'Vetted Products', desc: 'Every product is reviewed for quality and performance before it reaches our catalog.' },
              { icon: CheckCircle2, title: '30-Day Returns', desc: 'Not satisfied? Return any unused item within 30 days for a full refund.' },
              { icon: Award, title: 'Premium Quality', desc: 'We only list instruments that meet our strict quality standards.' },
            ].map((item, i) => (
              <div key={i} className="bg-dark-50 border border-dark-100 rounded-2xl p-6 text-center hover:border-athletic-300 transition-all group">
                <div className="w-14 h-14 bg-athletic-50 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:bg-athletic-100 transition-colors">
                  <item.icon className="w-7 h-7 text-athletic-700" />
                </div>
                <h3 className="font-display font-bold text-dark-900 text-lg mb-2">{item.title}</h3>
                <p className="text-dark-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="bg-dark-50 border border-dark-100 rounded-3xl p-8 md:p-12 mb-16">
            <h2 className="font-display text-2xl font-bold text-dark-900 mb-8 text-center">What we guarantee</h2>
            <div className="grid md:grid-cols-2 gap-6">
              {[
                'Products exactly as described on our website',
                'Genuine components and solid build quality',
                'Fast, secure shipping',
                '30-day money-back guarantee',
                'Secure payment processing',
                'Responsive customer support',
                'Authentic products, no counterfeits',
                'Safe packaging and handling',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-white rounded-xl border border-dark-100">
                  <CheckCircle2 className="w-5 h-5 text-athletic-600 flex-shrink-0" />
                  <span className="text-dark-900 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center bg-gradient-to-br from-athletic-50 to-power-50 border border-athletic-100 rounded-3xl p-12">
            <h2 className="font-display text-3xl font-bold text-dark-900 mb-4">Shop with confidence</h2>
            <p className="text-dark-600 mb-8 max-w-xl mx-auto">Experience our commitment to quality. Every purchase is backed by our satisfaction guarantee.</p>
            <Link to="/shop" className="inline-flex items-center gap-2 px-8 py-4 bg-athletic-500 text-white font-bold uppercase tracking-wider rounded-lg hover:opacity-90 transition-all shadow-button">Shop Now <ArrowRight className="w-5 h-5" /></Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default QualityGuaranteePage;
